import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
  Component,
  OnInit,
  HostBinding,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import * as $ from "jquery";
import { LeafletService } from "../../ng-leaflet/services/leaflet.service";
import { flyIn } from "../../animations/fly-in";
import { CartService } from "../service/cart.service";

@Component({
  selector: 'app-data-query',
  templateUrl: './data-query.component.html',
  styleUrls: ['./data-query.component.css'],
  providers: [LeafletService],
  animations: [flyIn]
})
export class DataQueryComponent implements OnInit {

  @HostBinding("@flyIn") routeAnimation = true;
  @HostBinding("style.display") display = "block";

  public leafletOptions: any; // 地图初始化配置
  public leafletLayersControl: any; // layersControl
  public leafletOption1: any; // 地图初始化配置
  public leafletLayersControl1: any; // layersControl
  public east: number; // 东经度
  public west: number; // 西经度
  public south: number; // 北纬度
  public north: number; // 南纬度
  public keywords: string; // 关键词
  public mapSearchUrl: string; // 地图搜索接口地址
  public sensorResolution: string; // 传感器/分辨率

  public bounds; //测试地图

  public isSensorModalVisible: boolean = false;
  public gsd: number; //分辨率
  public sensor = []; //传感器
  public visibleSidebar: boolean = false;
  public isMapDetail: boolean = false; //搜索地图显示数据

  public satellite; //光学卫星

  isCollapsed: boolean;

  _allChecked = false; //选择表格
  _disabledButton = true;
  _checkedNumber = 0;
  _displayData: Array<any> = [];
  _operating = false;
  _indeterminate = false;

  _current = 1; //表格分页参数
  _pageSize = 8;
  _total = 1;
  _mapList = [];
  _cartList: any[] = [];
  _loading = false;

  _cloudPercent = 0; //云量

  _level; //产品级别
  data: any[] = []; //添加购物车

  //删除成功框
  isVisible = false;

  imgUrl; //地图详情图片接口
  mapDetailUrl; //地图详情接口
  mapDetail; //地图详情信息

  latlngs; //定义画图
  LP;
  myGroup;

  LV;

  imgOver = []; //图片展示
  mapEyeUrl; //修改eye图片
  mapEyeList; //把带图片的urlList保存下来

  public _dateRange;


  sideBar: boolean = false;

  startDate

  public netType: string;
  showResTrigger: boolean = false; //是否显示结果sider开关
  constructor(
    private http: HttpClient,
    private leafletService: LeafletService,
    private datePipe: DatePipe,
    private cartService: CartService
  ) {
    this.netType = "internet";
    this.mapSearchUrl = "http://210.77.77.237:8080/dm/dataAttr/SelectByDataAttrVo"
    // this._dateRange = [new Date(2018, 11, 22), new Date(2018, 11, 23)];
    this._dateRange = [];
  }

  ngOnInit() {
    // 初始化地图
    this.leafletOptions = {
      center: [38.93, 99.92],
      minZoom: 2,
      maxZoom: 17,
      zoom: 8,
      layersControl: true,
      measureCtl: false,
      baseLayer: true,
      defaultExtentControl: false,
      attributionControl: false,
      zoomControl: false,

    };

    // 订阅绘制查询范围
    const bounds = this.leafletService.queryBounds.subscribe(data => {
      console.log(data);
      if (data) {
        this.south = +data.south;
        this.north = +data.north;
        this.west = +data.west;
        this.east = +data.east;
      } else {
        this.south = null;
        this.north = null;
        this.west = null;
        this.east = null;
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.leafletService.refresh();
    }, 200);


    // setTimeout(() => {
    //   this.leafletService.map.on('draw:created', function (event) {
    //     //var type = event.layerType;
    //     var layer = event.layer;
    //     console.log(JSON.stringify(layer.toGeoJSON()));

    //     // Create a new Wicket instance
    //     var wkt = new Wkt.Wkt();

    //     // // Read in any kind of WKT string
    //     // wkt.read("POLYGON ((30 10, 10 20, 20 40, 40 40, 30 10))");

    //     // Or a GeoJSON string
    //     var kk=wkt.read(JSON.stringify(layer.toGeoJSON())).write();
    //     console.log(kk);


    //     // Access and modify the underlying geometry
    //     console.log(wkt);
    //     // "[ [ {x: 30, y: 10}, {x: 10, y: 30}, ...] ]"
    //     wkt.components[0][1].x = 15;

    //     // wkt.merge(new Wkt.Wkt('POLYGON((35 15,15 25,25 45,45 45,35 15))'));
    //     wkt.write();
    //     // MULTIPOLYGON(((30 10,10 20,20 40,40 40,30 10)),((35 15,15 25,25 45,45 45,35 15)))

    //     console.log(wkt)
    //     // Create a geometry object, ready to be mapped!

    //     wkt.toObject();

    //     // Convert to GeoJSON
    //     wkt.toJson(); // Outputs an object
    //     var k=JSON.stringify(wkt.toJson()); // Outputs a string

    //     console.log(k);

    //   });
    // }, 1000);
  }



  checkboxChange(event) {
    console.log(event);

    this.satellite = event;
  }

  /**
   * 地图搜索
   */
  search() {
    this.sideBar = true;
    // const sidebar = document.getElementById("sidebar");
    // sidebar.style.cssText += "; display:block;";
    this.showResTrigger = true;
    this.isCollapsed = false;
    //搜索地图信息
    this.visibleSidebar = true;
    //搜索地图信息
    this._loading = true;

    let formData = new FormData();


    if (this.north != undefined) {
      console.log("ss");
      formData.append("topLeftLat", `${this.north}`);
    }

    if (this.west != undefined) {
      formData.append("topLeftLong ", `${this.west}`);
    }
    if (this.south != undefined) {
      formData.append("bottomRightLat ", `${this.south}`);
    }
    if (this.east != undefined) {
      formData.append("bottomRightLong ", `${this.east}`);
    }

    if (this.gsd != undefined) {
      formData.append("gsd", `${this.gsd}`); //分辨率
    }
    if (this.sensor.length > 0) {
      formData.append("sensor", `${this.sensor}`); //传感器
    }
    if (this.satellite != undefined) {
      formData.append("satellite", this.satellite); //光学卫星
    }
    formData.append("cloudPercent", `${this._cloudPercent}`);
    if (this._level != undefined) {
      formData.append("level", this._level);
    }
    formData.append("currentPage", `${this._current}`);
    formData.append("pageSize", `${this._pageSize}`);

    console.log(this._dateRange.length);
    if (this._dateRange.length > 0) {

      formData.append("startTime", this.datePipe.transform(this._dateRange[0], "yyyy-mm-dd hh"));
      formData.append("endTime", this.datePipe.transform(this._dateRange[1], "yyyy-mm-dd hh"));
    }




    const layers = [];

    if (this.myGroup != undefined) {
      this.leafletService.drawFeatureLayer.clearLayers(this.myGroup);
    }

    //105.231 104.941 105.327 37.8767
    // 获取地图查询结果,跳转路由
    this.http.post(this.mapSearchUrl, formData).subscribe(res => {
      this._loading = false;
      this._mapList = res["data"];
      this._total = res["recordsTotal"];
      this._displayData = this._mapList;

      const mapLists = res["data"];

      //查询结果反映到地图上
      mapLists.map(mapList => {
        this.latlngs = [
          [mapList["bottomLeftLat"], mapList["bottomLeftLong"]],
          [mapList["topLeftLat"], mapList["topLeftLong"]],
          [mapList["topRightLat"], mapList["topRightLong"]],
          [mapList["bottomRightLat"], mapList["bottomRightLong"]]
        ];
        const layer = L.polygon(this.latlngs, {
          color: "blue",
          fillColor: "none"
        });
        layers.push(layer);

        mapList["url"] =
          "http://210.77.77.237:8080/dm/dataAttr/image?id=" + 22;
        // "http://210.77.77.237:8080/dm/dataAttr/image?id=" + mapList.id;
      });
      this.mapEyeList = mapLists;

      //1. 判断是否输入参数（外边画大框，里边查询结果的小框）   2. 没有输入参数，但是有查询结果   3. 没有输入参数也没有查询结果
      if (
        this.north != undefined &&
        this.south != undefined &&
        this.east != undefined &&
        this.west != undefined
      ) {
        if (this.LP != undefined) {
          this.leafletService.map.removeLayer(this.LP);
        }
        this.latlngs = [
          [this.south, this.west],
          [this.north, this.west],
          [this.north, this.east],
          [this.south, this.east]
        ];
        this.LP = L.polygon(this.latlngs, { color: "blue", fillColor: "none" });
        this.leafletService.drawFeatureLayer.addLayer(this.LP);
        this.leafletService.map.fitBounds(this.latlngs);
      } else if (layers[0] != undefined) {
        this.leafletService.map.fitBounds(layers[0].getBounds());
      } else {
        this.leafletService.map.setView(L.latLng(34, 112));
      }

      this.myGroup = L.layerGroup(layers);
      this.leafletService.drawFeatureLayer.addLayer(this.myGroup);
    });
  }

  getMapLangs(event) {
    //清空上一次输入参数
    if (this.LP != undefined) {
      this.leafletService.map.removeLayer(this.LP);
    }
    //判断查询结果是否存在，存在删除
    if (this.myGroup != undefined) {
      this.myGroup.clearLayers();
    }

    if (
      this.west != undefined &&
      this.east != undefined &&
      this.south != undefined &&
      this.north != undefined
    ) {
      this.latlngs = [
        [this.south, this.west],
        [this.north, this.west],
        [this.north, this.east],
        [this.south, this.east]
      ];
      this.LP = L.polygon(this.latlngs, { background: "rgba(0, 0, 0, 0.4)" });
      this.leafletService.drawFeatureLayer.addLayer(this.LP);
      this.leafletService.map.fitBounds(this.latlngs);
    }
  }

  //点击页码执行
  refreshData() {
    this.search();
  }

  //云百分比
  increase() {
    this._cloudPercent = this._cloudPercent + 10;
    if (this._cloudPercent > 100) {
      this._cloudPercent = 100;
    }
  }

  decline() {
    this._cloudPercent = this._cloudPercent - 10;
    if (this._cloudPercent < 0) {
      this._cloudPercent = 0;
    }
  }

  //打开地图详情对话框
  mapSearchDetail(mapDetail) {
    this.isMapDetail = true;
    this.visibleSidebar = false;

    this.http
      .post(this.mapDetailUrl + "?id=" + mapDetail, {})
      .subscribe(res => {
        this.mapDetail = res;
        if (this.LV != undefined) {
          this.leafletService.map.removeLayer(this.LV);
        }
        const latlngs = [
          [res["bottomLeftLat"], res["bottomLeftLong"]],
          [res["topLeftLat"], res["topLeftLong"]],
          [res["topRightLat"], res["topRightLong"]],
          [res["bottomRightLat"], res["bottomRightLong"]]
        ];
        this.LV = L.polygon(latlngs, { background: "rgba(0, 0, 0, 0.4)" });
        setTimeout(() => {
          const polygon = this.LV.addTo(this.leafletService.map);
          // zoom the map to the polygon
          this.leafletService.map.fitBounds(polygon.getBounds());
        }, 100);
      });
  }

  /**
   * 打开地图图片详情
   * @param mapid
   */
  mapIMG(mapid) {
    const layers = [];
    this.mapEyeList.map(mapList => {
      this.latlngs = [
        [mapList["bottomLeftLat"], mapList["bottomLeftLong"]],
        [mapList["topLeftLat"], mapList["topLeftLong"]],
        [mapList["topRightLat"], mapList["topRightLong"]],
        [mapList["bottomRightLat"], mapList["bottomRightLong"]]
      ];
      const layer = L.polygon(this.latlngs, {
        color: "blue",
        fillColor: "none"
      });
      layers.push(layer);

      if (mapid == mapList.id) {
        if (this.imgOver[mapid] != undefined) {
          this.leafletService.drawFeatureLayer.removeLayer(this.imgOver[mapid]);
          this.imgOver[mapid] = undefined;

          mapList["eye"] = undefined;
        } else {
          const imageUrl = mapList["url"];
          const anchors = [
            [mapList["topLeftLat"], mapList["topLeftLong"]],
            [mapList["topRightLat"], mapList["topRightLong"]],
            [mapList["bottomRightLat"], mapList["bottomRightLong"]],
            [mapList["bottomLeftLat"], mapList["bottomLeftLong"]]
          ],
            clipCoords = [
              [mapList["topLeftLat"], mapList["topLeftLong"]],
              [mapList["topRightLat"], mapList["topRightLong"]],
              [mapList["bottomRightLat"], mapList["bottomRightLong"]],
              [mapList["bottomLeftLat"], mapList["bottomLeftLong"]],
              [mapList["topLeftLat"], mapList["topLeftLong"]]
            ];
          this.imgOver[mapid] = L.imageTransform(imageUrl, anchors, {
            clip: clipCoords
          });

          // var topleft = L.latLng(mapList["topLeftLat"], mapList["topLeftLong"]),
          //   topright = L.latLng(mapList["topRightLat"], mapList["topRightLong"]),
          //   bottomleft = L.latLng(mapList["bottomLeftLat"], mapList["bottomLeftLong"]);

          // this.imgOver[mapid] = L.imageOverlay.rotated(imageUrl, topleft, topright, bottomleft, {
          //   opacity: 0.8,
          //   intreactive: true
          // })

          this.leafletService.drawFeatureLayer.addLayer(this.imgOver[mapid]);

          mapList["eye"] = 1;
        }
      }
    });

    this._mapList = this.mapEyeList;
    //1. 判断是否输入参数（外边画大框，里边查询结果的小框）   2. 没有输入参数，但是有查询结果   3. 没有输入参数也没有查询结果
    if (
      this.north != undefined &&
      this.south != undefined &&
      this.east != undefined &&
      this.west != undefined
    ) {
      if (this.LP != undefined) {
        this.leafletService.map.removeLayer(this.LP);
      }
      this.latlngs = [
        [this.south, this.west],
        [this.north, this.west],
        [this.north, this.east],
        [this.south, this.east]
      ];
      this.LP = L.polygon(this.latlngs, { color: "blue", fillColor: "none" });
      this.leafletService.drawFeatureLayer.addLayer(this.LP);
    }

    this.myGroup = L.layerGroup(layers);
    this.leafletService.drawFeatureLayer.addLayer(this.myGroup);
  }

  handleCancelMiddle() {
    this.isMapDetail = false;
    this.visibleSidebar = true;
  }

  // 组件destroy时清空绘制图形
  ngOnDestroy() {
    //Called once, before the instaisSensorModalVisiblence is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.leafletService.drawFeatureLayer.clearLayers();
  }

  //选择框
  chooseSensorRes() {
    this.isSensorModalVisible = true;
  }
  handleSensorModalOk() {
    this.isSensorModalVisible = false;
    if (this.gsd != undefined && this.sensor != undefined) {
      this.sensorResolution =
        "传感器：" + this.sensor + ",  分辨率：" + this.gsd;
    } else if (this.gsd == undefined && this.sensor != undefined) {
      this.sensorResolution = "传感器：" + this.sensor;
    } else if (this.gsd != undefined && this.sensor == undefined) {
      this.sensorResolution = "分辨率：" + this.gsd;
    }
  }
  handleSensorModalCancle() {
    this.isSensorModalVisible = false;
  }

  /**
   * 添加购物车
   */
  _operateData() {
    let j = 0;

    for (let i = 0; i < this._displayData.length; i++) {
      if (this._displayData[i].checked) {
        this.data[j] = this._displayData[i].id;
        j = j + 1;
      }
    }
    // //添加购物车
    this.cartService.addCart(this.data).subscribe(res => {
      if (res["InsertList"].length == 0) {
        this._operating = true;
        setTimeout(_ => {
          this._mapList.forEach(value => (value.checked = false));
          this._refreshStatus();
          this._operating = false;
        }, 1000);

        alert("添加成功");
        this.visibleSidebar = false;
      } else {
        this._cartList = res["InsertList"];
        let cart = "";
        cart += "(";
        for (let i = 0; i < this._cartList.length; i++) {
          if (this._cartList[i] != null) {
            cart += this._cartList[i];
            cart += ",";
          }
        }

        cart += ")";
        cart = cart.replace(",)", ")");
        alert("购物车中已有" + cart + "商品");
      }
    });
  }

  _refreshStatus() {
    const allChecked = this._displayData.every(value => value.checked === true);
    const allUnChecked = this._displayData.every(value => !value.checked);
    this._allChecked = allChecked;
    this._indeterminate = !allChecked && !allUnChecked;
    this._disabledButton = !this._mapList.some(value => value.checked);
    this._checkedNumber = this._mapList.filter(value => value.checked).length;
  }

  _checkAll(value) {
    if (value) {
      this._displayData.forEach(data => (data.checked = true));
    } else {
      this._displayData.forEach(data => (data.checked = false));
    }
    this._refreshStatus();
  }

  closeModel() {
    this.visibleSidebar = true;
    this.isVisible = false;
  }

  resetForm($event: MouseEvent) {
    this.east = null;
    this.west = null;
    this.north = null;
    this.south = null;
    this.satellite = null;
    this.sensor = null;
    this.gsd = null;
    this._level = null;
    this._cloudPercent = 0;
    this.sensorResolution = null;
    if (this.LV != undefined) {
      this.leafletService.map.removeLayer(this.LV);
    }
    if (this.LP != undefined) {
      this.leafletService.map.removeLayer(this.LP);
    }
    if (this.myGroup != undefined) {
      this.myGroup.clearLayers();
    }
  }

  refresh() {
    //只有当初始化map时才触发resize事件，并刷新地图
    this.isCollapsed = !this.isCollapsed;
    setTimeout(() => {
      this.leafletService.refresh();
    }, 500);
  }
}
